import {reduce} from 'lodash';

export function composeReducers(...funcs) {
    return function(state, action) {
        return reduce(funcs, (aggregateState, f) => {
            return f(aggregateState, action);
        }, state);
    };
}
